import whiteTickSvg from '../../../assets/whiteTick.svg';
import {
  TApplicationStage,
  TApplicationSubStage,
  TApplicationSubStageObject,
} from '../../../Customers.types';

const mapStageToNumber = (stage: TApplicationStage['value']) => {
  switch (stage) {
    case 'business_details':
      return 1;
    case 'security':
      return 2;
  }
};

const mapStageToText = (stage: TApplicationStage['value']) => {
  switch (stage) {
    case 'business_details':
      return 'Business Details';
    case 'security':
      return 'Security checks';
  }
};

export const countCompletedSteps = (
  applicationSubStages: TApplicationSubStageObject,
  subStagesToCount: TApplicationSubStage[],
) => {
  return subStagesToCount.reduce(
    (count, key) => (applicationSubStages[key]?.completed ? count + 1 : count),
    0,
  );
};

export const ApplicationStage = ({
  stage,
  currentStage,
  children,
}: {
  stage: TApplicationStage['value'];
  currentStage: TApplicationStage['value'];
  children: React.ReactNode;
}) => {
  const isComplete = () => {
    if (stage === 'business_details') {
      return currentStage !== 'business_details';
    }

    return false;
  };

  const isCurrent = () => {
    return stage === currentStage;
  };

  if (isComplete()) {
    return (
      <>
        <>
          <div className="] flex h-[30px] w-[30px] items-center justify-center justify-self-center rounded-2xl bg-primary-20 text-l text-structure-100">
            <img src={whiteTickSvg} alt="check icon" />
          </div>
          <div className="flex items-center font-bold text-structure-40">
            {mapStageToText(stage)}
          </div>
        </>
        <>
          <div className="w-[4px] justify-self-center bg-primary-20 pb-l"></div>
          <div />
        </>
      </>
    );
  }

  if (isCurrent()) {
    return (
      <>
        <>
          <div className="flex h-[36px] w-[36px] items-center justify-center rounded-2xl border-[3px] border-secondary-80 bg-primary-20 text-l text-structure-100">
            {mapStageToNumber(stage)}
          </div>
          <div className="flex items-center font-bold">
            {mapStageToText(stage)}
          </div>
        </>
        {children}
      </>
    );
  }

  return (
    <>
      <>
        <div className="w-[4px] justify-self-center bg-structure-80 pb-l"></div>
        <div />
      </>
      <>
        <div className="flex h-[30px] w-[30px] items-center justify-center justify-self-center rounded-2xl bg-structure-80 text-l text-structure-100">
          {mapStageToNumber(stage)}
        </div>
        <div className="flex items-center font-bold text-structure-40">
          {mapStageToText(stage)}
        </div>
      </>
    </>
  );
};
